
import useCanvasImage from './UseCanvasImage';
const CanvasImage = ({image, textToOverlay, xLoc, yLoc, fontName, fontSize}) => {
  const { canvasRef } = useCanvasImage(image, textToOverlay, xLoc, yLoc, fontName, fontSize);

  return <canvas ref={canvasRef} />
}

export default CanvasImage;
